import React from 'react';
import '../styles/TermNotFoundAlert.css';

const TermNotFoundAlert = () => {
    const githubLink = "https://github.com/DefconParrot/Defcon-Glossary/issues/new?assignees=&labels=dc_term&projects=&template=term-submission.yml";
  
    return (
      <div className="term-not-found-container">
        <h2 className="term-not-found-title">Term Not Found 🕵️</h2>
        <p className="term-not-found-text">
          We couldn't find the term you were looking for. You can help us by
          suggesting this term for addition in our glossary.
        </p>
        <a
          className="term-not-found-button"
          href={githubLink}
          target="_blank"
          rel="noopener noreferrer"
        >
          Suggest Term⭜
        </a>
      </div>
    );
  };
  
  export default TermNotFoundAlert;